import { defaultInputProps } from '../../../../FormContainer/defaultFormStates';

export const verticalList = [
  { display: 'Auto', value: 'auto' },
  { display: 'Home', value: 'home' },
  { display: 'Pet', value: 'pet' },
  { display: 'Life', value: 'life' },
  { display: 'Medicare', value: 'medicare' },
  { display: 'Commercial', value: 'commercial' },
  { display: 'Health', value: 'health' },
  { display: 'Final Expense', value: 'final expense' }
];
export const buyerIntegrationState = () => ({
  account_owner_name: {
    ...defaultInputProps,
    name: 'account_owner_name',
    label: "What is the OTTO sales account owner's name?",
    value: '',
    message: 'Please enter the OTTO sales account owner name'
  },
  account_owner_email: {
    ...defaultInputProps,
    name: 'account_owner_email',
    label: "What is the OTTO sales account owner's email?",
    value: '',
    message: 'Please enter the OTTO sales account owner email'
  },
  buyer_name: {
    ...defaultInputProps,
    name: 'buyer_name',
    label: 'What deal / client is this request for?',
    value: '',
    message: 'Please enter the deal / client this request is for'
  },
  client_email: {
    ...defaultInputProps,
    name: 'client_name',
    label: "What is the client's email?",
    value: '',
    message: "Please enter the client's email"
  },
  client_name: {
    ...defaultInputProps,
    name: 'client_name',
    label: "What is the client's name?",
    value: '',
    message: "Please enter the client's name"
  },
  buyer_partners_list_name: {
    ...defaultInputProps,
    name: 'buyer_partners_list_name',
    label: 'How should the company be listed in our marketing partners list?',
    value: '',
    message:
      'Please enter how the company should be listed in our marketing partners list'
  },
  vertical: {
    name: 'vertical',
    type: 'select',
    label: 'Vertical',
    validate: () => {},
    options: () => verticalList,
    value: 'auto',
    defaultVal: '',
    inputWidth: 3
  },
  is_spec_document: {
    ...defaultInputProps,
    name: 'is_spec_document',
    label: 'Is the Spec in a document?',
    value: false
  },
  spec_document: {
    value: null,
    label: 'Upload Spec Document',
    defaultVal: null,
    message: 'Please upload a spec document'
  },
  spec_url: {
    ...defaultInputProps,
    name: 'spec_url',
    label: 'Link to URL specs',
    value: '',
    message: 'Please enter a link to URL specs'
  },
  campaigns_active: {
    ...defaultInputProps,
    name: 'campaigns_active',
    label: 'Are campaigns active on the buyer side?',
    value: false
  },
  contracts_signed: {
    ...defaultInputProps,
    name: 'contracts_signed',
    label: 'Are contracts signed?',
    value: false
  },
  bid_components_done: {
    ...defaultInputProps,
    name: 'bid_components_done',
    label: 'Are all components of bids done?',
    value: false
  },
  buyer_notes: {
    ...defaultInputProps,
    name: 'buyer_notes',
    label:
      'Please list any and all notes you feel are vital/relevant to this submission for the team.',
    value: '',
    message:
      'Please list any and all notes you feel are vital/relevant to this submission for the team',
    optional: true
  }
});
